import { render, staticRenderFns } from "./aOrderDetailDiscounts.vue?vue&type=template&id=490fbed2&scoped=true"
import script from "./aOrderDetailDiscounts.vue?vue&type=script&lang=js"
export * from "./aOrderDetailDiscounts.vue?vue&type=script&lang=js"
import style0 from "./aOrderDetailDiscounts.vue?vue&type=style&index=0&id=490fbed2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490fbed2",
  null
  
)

export default component.exports